/**
 * The 'IDLE' action.
 * @type {'IDLE'}
 * @constant
 */
const IDLE = 'IDLE';

/**
 * The 'SELECT' action.
 * @type {'SELECT'}
 * @constant
 */
const SELECT = 'SELECT';

export {

    IDLE,
    SELECT
};
